<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Branch Name</label>
                  <b-form-input type="text"  v-model="form.branchname" ref='firstInput' @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Branch Head</label>
                  <b-form-input type="text"  v-model="form.branchhead" @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Email</label>
                  <b-form-input type="text"  v-model="form.email" @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>State</label>
                  <select class="form-control" v-model="form.statecode">
                    <option value="">Select state</option>
                    <option v-for="state in states" :key="state.statecode" :value="state.statecode">
                      {{ state.statename }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-12 col-12">
                <div class="form-group">
                  <label>Phone</label>
                  <b-form-input type="text"  v-model="form.phone" @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Submit</a>
                <router-link to="customerlist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
export default {
  data() {
    return {
      form: {
        branchname: '',
        branchhead: '',
        email: '',
        phone:'',
        statecode: '',
      },
      states: [],
      title: "Branch Management",
      title1: "Add Branch",
    };
  },
  methods: {
    async getStates() {
      const response = await axios.get('/v1/states');
      this.states = response.data;
    },
    async postData() {
      if (!this.form.branchname) {
        Swal.fire("Please enter the branch name");
        return;
      }
      if (!this.form.statecode) {
        Swal.fire("Please select a state");
        return;
      }
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you really want to submit the form?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, submit it!'
      });

      if (result.isConfirmed) {
      axios
      .post('/v1/branches', this.form)
      .then(response => {
        Swal.fire("Branch created successfully");
        this.$router.push({ path: '/customerlist' });
      })
      .catch(error => {
        console.log(error)
        Swal.fire(error.response.data.detail);
      });
      }
    },
    submitForm() {
      this.postData();
    }
  },
  async beforeMount() {
    await this.getStates();
  },
  mounted(){
    this.$refs.firstInput.focus();
  },
  name: "addcustomer",
};
</script>
